import { createTheme } from '@mui/material/styles' // Create a theme instance
const theme = createTheme({
  palette: {
    custom: {
      main: '#692929',
      hover: 'rgb(105,41,41,0.9)',
      light: '#875353',
      dark: '#491C1C',
      contrastText: '#ffffff',
      gradient:
        'linear-gradient(90deg, rgba(255,99,99,1) 0%, rgba(85,22,22,1) 100%)',
      captionHeaderHeight: 58,
      mobileCaptionHeaderHeight: 80,
      headerHeight: 70,
      xlPaddingInline: 420,
      lgPaddingInline: 80,
      smPaddingInline: 12,
      boxShadow: '0px 5px 15px 5px rgb(0 0 0 / 10%)',
    },
    secondary: {
      main: '#692929',
      light: '#875353',
      dark: '#491C1C',
      contrastText: '#fff',
    },
    error: {
      main: '#ff2020',
      light: '#ff644c',
      dark: '#c30000',
      contrastText: '#FF2083',
    },
  },
  typography: {
    fontFamily: 'Lato, sans-serif',
    h1: {
      fontSize: 64,
      fontWeight: 500,
    },
    h2: {
      fontSize: 36,
      fontWeight: 500,
    },
    h3: {
      fontSize: 28,
      fontWeight: 400,
    },
    h4: {
      fontSize: 24,
      fontWeight: 400,
    },
    h5: {
      fontSize: 20,
      fontWeight: 400,
    },
    h6: {
      fontSize: 18,
      fontWeight: 400,
    },
    body1: {
      fontSize: 16,
      fontWeight: 400,
    },
    body2: {
      fontSize: 14,
      fontWeight: 400,
    },
    subtitle1: {
      fontSize: 12,
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: 10,
      fontWeight: 400,
    },
    caption: {
      fontSize: 8,
      fontWeight: 400,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: 12,
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          fontSize: 10,
        },
      },
    },
    MuiDayPicker: {
      weekDayLabel: {
        fontSize: 10,
      },
    },
  },
})

export default theme
